// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FileBox{flex:1}.dropbox{background:#e0ffff;color:dimgray;min-height:150px;outline:2px dashed gray;outline-offset:-10px;padding:10px;position:relative}.dropbox,.input-file{cursor:pointer;height:150px}.input-file{opacity:0;position:absolute;width:100%}.dropbox:hover{background:#add8e6!important}.dropbox p{font-size:1.2em;padding:25px 0;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
